export const themeFamilies = [
  {
    id: "signature",
    label: "Signature",
    colours: [
      { key: "custom", label: "Green", palette: "green", swatch: "#176b52" },
      { key: "custom-blue", label: "Blue", palette: "blue", swatch: "#1e4f93" },
      {
        key: "custom-purple",
        label: "Purple",
        palette: "purple",
        swatch: "#715097",
      },
      { key: "custom-teal", label: "Teal", palette: "teal", swatch: "#0f6974" },
      {
        key: "custom-amber",
        label: "Amber",
        palette: "amber",
        swatch: "#925b1c",
      },
      {
        key: "custom-graphite",
        label: "Graphite",
        palette: "graphite",
        swatch: "#525d69",
      },
    ],
  },
  {
    id: "studio",
    label: "Studio",
    colours: [
      { key: "studio", label: "Blue", palette: "blue", swatch: "#315b91" },
      {
        key: "studio-green",
        label: "Green",
        palette: "green",
        swatch: "#287151",
      },
      {
        key: "studio-purple",
        label: "Purple",
        palette: "purple",
        swatch: "#795389",
      },
      { key: "studio-teal", label: "Teal", palette: "teal", swatch: "#216e78" },
      {
        key: "studio-amber",
        label: "Amber",
        palette: "amber",
        swatch: "#986321",
      },
      {
        key: "studio-graphite",
        label: "Graphite",
        palette: "graphite",
        swatch: "#515b68",
      },
    ],
  },
];
export const palettes = Object.fromEntries(
  themeFamilies.flatMap((family) =>
    family.colours.map((colour) => [
      colour.key,
      { ...colour, family: family.id },
    ]),
  ),
);
// The supported Bootswatch catalogue: styles with dark native surfaces live
// together. Quartz is deliberately excluded from Claimsdesk.
export const lightThemes = [
  "claimsdesk",
  "cerulean",
  "cosmo",
  "flatly",
  "journal",
  "litera",
  "lumen",
  "lux",
  "materia",
  "minty",
  "morph",
  "pulse",
  "sandstone",
  "simplex",
  "sketchy",
  "spacelab",
  "united",
  "yeti",
  "zephyr",
];
export const darkThemes = [
  "cyborg",
  "darkly",
  "slate",
  "solar",
  "superhero",
  "vapor",
];
export const themes = [...lightThemes, ...darkThemes].sort();
const namedOptions = (keys) =>
  keys.map((key) => ({
    key,
    label:
      key === "claimsdesk"
        ? "Bootstrap (ClaimsDesk)"
        : key.charAt(0).toUpperCase() + key.slice(1),
  }));
export const themeGroups = [
  ...themeFamilies.map(({ id, label, colours }) => ({
    id,
    label,
    items: colours,
  })),
  { id: "light", label: "Light themes", items: namedOptions(lightThemes) },
  { id: "dark", label: "Dark themes", items: namedOptions(darkThemes) },
];
// Preserve the existing plain-Bootstrap preference key and default. The old
// experimental robs-choice remains hidden, with its existing Zephyr fallback.
export function normaliseTheme(value) {
  let key = value || "zephyr";
  if (key === "bootstrap") key = "claimsdesk";
  if (key === "studio-blue") key = "studio";
  if (key === "quartz") key = "darkly"; // Retired; keep existing users in dark mode.
  return Object.hasOwn(palettes, key) || themes.includes(key) ? key : "zephyr";
}
export const bootswatchThemes = themes.filter((key) => key !== "claimsdesk");
